import ServiceRangesPage from './ServiceRangesPage'
export default ServiceRangesPage